import React, { useState } from 'react';
import { PlusIcon, SearchIcon, FilterIcon, DownloadIcon, MoreHorizontalIcon, TrashIcon, PencilIcon, EyeIcon } from 'lucide-react';
export const SpuManagement = () => {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  // Sample data for the SPU table
  const spuData = [{
    id: 'SPU-12345',
    name: 'iPhone 15 Pro',
    brand: 'Apple',
    category: 'Smartphones',
    status: 'Active',
    createdDate: '2023-05-01'
  }, {
    id: 'SPU-12346',
    name: 'Galaxy S24 Ultra',
    brand: 'Samsung',
    category: 'Smartphones',
    status: 'Active',
    createdDate: '2023-05-02'
  }, {
    id: 'SPU-12347',
    name: 'MacBook Air M2',
    brand: 'Apple',
    category: 'Laptops',
    status: 'Active',
    createdDate: '2023-05-03'
  }, {
    id: 'SPU-12348',
    name: 'iPad Pro 12.9"',
    brand: 'Apple',
    category: 'Tablets',
    status: 'Pending',
    createdDate: '2023-05-04'
  }, {
    id: 'SPU-12349',
    name: 'Galaxy Tab S9',
    brand: 'Samsung',
    category: 'Tablets',
    status: 'Inactive',
    createdDate: '2023-05-05'
  }, {
    id: 'SPU-12350',
    name: 'AirPods Pro 2',
    brand: 'Apple',
    category: 'Audio',
    status: 'Active',
    createdDate: '2023-05-06'
  }, {
    id: 'SPU-12351',
    name: 'Apple Watch Series 9',
    brand: 'Apple',
    category: 'Smartwatches',
    status: 'Active',
    createdDate: '2023-05-07'
  }, {
    id: 'SPU-12352',
    name: 'Galaxy Watch 6',
    brand: 'Samsung',
    category: 'Smartwatches',
    status: 'Pending',
    createdDate: '2023-05-08'
  }, {
    id: 'SPU-12353',
    name: 'Pixel 8 Pro',
    brand: 'Google',
    category: 'Smartphones',
    status: 'Active',
    createdDate: '2023-05-09'
  }, {
    id: 'SPU-12354',
    name: 'Surface Pro 9',
    brand: 'Microsoft',
    category: 'Laptops',
    status: 'Inactive',
    createdDate: '2023-05-10'
  }];
  const toggleSelectAll = () => {
    if (selectedItems.length === spuData.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(spuData.map(item => item.id));
    }
  };
  const toggleSelectItem = (id: string) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter(itemId => itemId !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };
  const getStatusBadgeClass = (status: string) => {
    switch (status) {
      case 'Active':
        return 'bg-green-100 text-green-800';
      case 'Pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'Inactive':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div className="space-y-6" data-id="element-2232">
      <div className="flex justify-between items-center" data-id="element-2233">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-2234">SPU Management</h1>
        <button className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors flex items-center" data-id="element-2235">
          <PlusIcon className="h-5 w-5 mr-1" data-id="element-2236" />
          Add New SPU
        </button>
      </div>
      {/* Filters and Search */}
      <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-200" data-id="element-2237">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-2238">
          <div className="flex flex-col sm:flex-row gap-3" data-id="element-2239">
            <div className="relative" data-id="element-2240">
              <select className="appearance-none pl-3 pr-10 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2241">
                <option value="" data-id="element-2242">All Brands</option>
                <option value="Apple" data-id="element-2243">Apple</option>
                <option value="Samsung" data-id="element-2244">Samsung</option>
                <option value="Google" data-id="element-2245">Google</option>
                <option value="Microsoft" data-id="element-2246">Microsoft</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-2247">
                <FilterIcon className="h-4 w-4 text-gray-400" data-id="element-2248" />
              </div>
            </div>
            <div className="relative" data-id="element-2249">
              <select className="appearance-none pl-3 pr-10 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2250">
                <option value="" data-id="element-2251">All Categories</option>
                <option value="Smartphones" data-id="element-2252">Smartphones</option>
                <option value="Tablets" data-id="element-2253">Tablets</option>
                <option value="Laptops" data-id="element-2254">Laptops</option>
                <option value="Smartwatches" data-id="element-2255">Smartwatches</option>
                <option value="Audio" data-id="element-2256">Audio</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-2257">
                <FilterIcon className="h-4 w-4 text-gray-400" data-id="element-2258" />
              </div>
            </div>
            <div className="relative" data-id="element-2259">
              <select className="appearance-none pl-3 pr-10 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2260">
                <option value="" data-id="element-2261">All Status</option>
                <option value="Active" data-id="element-2262">Active</option>
                <option value="Pending" data-id="element-2263">Pending</option>
                <option value="Inactive" data-id="element-2264">Inactive</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-2265">
                <FilterIcon className="h-4 w-4 text-gray-400" data-id="element-2266" />
              </div>
            </div>
          </div>
          <div className="relative w-full md:w-64" data-id="element-2267">
            <input type="text" placeholder="Search SPUs..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2268" />
            <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-2269" />
          </div>
        </div>
      </div>
      {/* Bulk Actions */}
      {selectedItems.length > 0 && <div className="bg-blue-50 rounded-lg p-4 border border-blue-200 flex justify-between items-center" data-id="element-2270">
          <span className="text-blue-700 font-medium" data-id="element-2271">
            {selectedItems.length} items selected
          </span>
          <div className="flex space-x-3" data-id="element-2272">
            <button className="text-red-600 hover:text-red-800 py-2 px-3 rounded-md border border-red-200 bg-white hover:bg-red-50 flex items-center" data-id="element-2273">
              <TrashIcon className="h-4 w-4 mr-1" data-id="element-2274" />
              Delete
            </button>
            <button className="text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md border border-gray-200 bg-white hover:bg-gray-50 flex items-center" data-id="element-2275">
              <DownloadIcon className="h-4 w-4 mr-1" data-id="element-2276" />
              Export
            </button>
            <button className="text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md border border-gray-200 bg-white hover:bg-gray-50" data-id="element-2277">
              Change Status
            </button>
          </div>
        </div>}
      {/* SPU Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2278">
        <div className="overflow-x-auto" data-id="element-2279">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-2280">
            <thead className="bg-gray-50" data-id="element-2281">
              <tr data-id="element-2282">
                <th scope="col" className="px-6 py-3 text-left" data-id="element-2283">
                  <div className="flex items-center" data-id="element-2284">
                    <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" checked={selectedItems.length === spuData.length} onChange={toggleSelectAll} data-id="element-2285" />
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2286">
                  SPU ID
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2287">
                  Product Name
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2288">
                  Brand
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2289">
                  Category
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2290">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2291">
                  Created Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2292">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2293">
              {spuData.map(spu => <tr key={spu.id} className="hover:bg-gray-50" data-id="element-2294">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2295">
                    <div className="flex items-center" data-id="element-2296">
                      <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" checked={selectedItems.includes(spu.id)} onChange={() => toggleSelectItem(spu.id)} data-id="element-2297" />
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2298">
                    {spu.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-2299">
                    {spu.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2300">
                    {spu.brand}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2301">
                    {spu.category}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2302">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadgeClass(spu.status)}`} data-id="element-2303">
                      {spu.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2304">
                    {spu.createdDate}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-2305">
                    <div className="flex space-x-2" data-id="element-2306">
                      <button className="text-blue-600 hover:text-blue-900" data-id="element-2307">
                        <EyeIcon className="h-5 w-5" data-id="element-2308" />
                      </button>
                      <button className="text-green-600 hover:text-green-900" data-id="element-2309">
                        <PencilIcon className="h-5 w-5" data-id="element-2310" />
                      </button>
                      <button className="text-red-600 hover:text-red-900" data-id="element-2311">
                        <TrashIcon className="h-5 w-5" data-id="element-2312" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-900" data-id="element-2313">
                        <MoreHorizontalIcon className="h-5 w-5" data-id="element-2314" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-2315">
          <div className="text-sm text-gray-700" data-id="element-2316">
            Showing <span className="font-medium" data-id="element-2317">1</span> to{' '}
            <span className="font-medium" data-id="element-2318">10</span> of{' '}
            <span className="font-medium" data-id="element-2319">97</span> results
          </div>
          <div className="flex space-x-2" data-id="element-2320">
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2321">
              Previous
            </button>
            <button className="px-3 py-1 border border-blue-600 rounded-md bg-blue-600 text-white hover:bg-blue-700" data-id="element-2322">
              1
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50" data-id="element-2323">
              2
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50" data-id="element-2324">
              3
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50" data-id="element-2325">
              ...
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50" data-id="element-2326">
              10
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50" data-id="element-2327">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
};